import React from "react";
import { PersonaTranscriptTypes } from "../../../types/ContentCard";
import { PersonaMessage } from "./PersonaTranscriptStyles";

const PersonaTranscript: React.FC<{
  contentCardData: PersonaTranscriptTypes;
  index: number;
}> = ({ contentCardData, index }) => {
  return (
    <>
      {contentCardData.data.transcript.split("----").map((message, ind) => {
        // For some reason the cx payload send a .
        // this line filters those out
        if (message === ". " || message === ".  ") return null;
        return (
          <PersonaMessage index={index} key={ind}>
            <div className="talk-bubble tri-right round btm-left">
              <div className="talktext">
                {message.split("---").map((elem, i) => (
                  <p key={i} style={{ marginBottom: "10px" }}>
                    {elem}
                    <br />
                  </p>
                ))}
              </div>
            </div>
          </PersonaMessage>
        );
      })}
    </>
  );
};

export default PersonaTranscript;
